export default "__VITE_ASSET__BkdMiJeX__"